export function SkeletonBox({ className = "" }) {
  return <div className={`skeleton-shimmer rounded-md ${className}`} />;
}

export function SkeletonTable({ rows = 6, cols = 5 }) {
  return (
    <div className="border rounded-xl overflow-hidden bg-background shadow-elev-1">
      <div className="grid gap-3 px-4 py-3 border-b bg-muted/30" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0,1fr))` }}>
        {Array.from({ length: cols }).map((_, i) => (
          <SkeletonBox key={i} className="h-3 w-16" />
        ))}
      </div>
      <div className="divide-y">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className="grid gap-3 px-4 py-3.5" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0,1fr))` }}>
            {Array.from({ length: cols }).map((_, c) => (
              <SkeletonBox key={c} className="h-3.5 w-full" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonKPICard() {
  return (
    <div className="border rounded-xl p-5 bg-background shadow-elev-1">
      <div className="flex items-center justify-between mb-3">
        <SkeletonBox className="h-3 w-20" />
        <SkeletonBox className="h-4 w-4 rounded" />
      </div>
      <SkeletonBox className="h-7 w-28" />
      <SkeletonBox className="h-3 w-16 mt-2.5" />
    </div>
  );
}
